var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"calc-block-cell",class:'calc-block-cell--' + _vm.block,attrs:{"rowspan":_vm.rows,"title":_vm.compact ? _vm.title : ''}},[_c('b',[_vm._v(_vm._s(_vm.block.toUpperCase()))]),(!_vm.compact)?_c('span',{staticClass:"calc-block-cell__name"},[_vm._v(_vm._s(_vm.name))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }